import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaExpand } from "react-icons/fa";

const ContractGridItem = ({
  contract,
  isAdmin,
  toggleModal,
  setSelectedContract,
  statusColors,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1"
    >
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-lg font-semibold text-gray-800">
            {contract["Contract Number"]}
          </h3>
          <span
            className={`px-2 py-1 text-xs font-semibold rounded-full ${
              statusColors[contract.status]
            }`}
          >
            {contract.status}
          </span>
        </div>
        <div
          className={`text-sm text-gray-600 mb-2 ${
            isExpanded ? "" : "h-12 overflow-hidden"
          }`}
        >
          <p>{contract["Contract Description"]}</p>
        </div>
        {!isExpanded && contract["Contract Description"].length > 100 && (
          <button
            onClick={() => setIsExpanded(true)}
            className="text-indigo-600 hover:text-indigo-800 text-sm flex items-center"
          >
            <FaExpand className="mr-1" /> Expand description
          </button>
        )}
        <p className="text-xs text-gray-500">Category: {contract.category}</p>
        <p className="text-xs text-gray-500">Parties: {contract.Parties}</p>
        <p className="text-xs text-gray-500">
          {new Date(contract.startDate).toLocaleDateString()} -{" "}
          {new Date(contract.endDate).toLocaleDateString()}
        </p>
      </div>
      <div className="bg-gray-50 px-4 py-3 flex justify-end">
        {isAdmin && (
          <button
            onClick={() => toggleModal(contract)}
            className="text-indigo-600 hover:text-indigo-800 mr-3 transition duration-300"
          >
            Manage
          </button>
        )}
        <button
          onClick={() => setSelectedContract(contract)}
          className="text-emerald-600 hover:text-emerald-800 transition duration-300"
        >
          View Details
        </button>
      </div>
    </motion.div>
  );
};

const ContractsGrid = ({
  currentContracts,
  isAdmin,
  toggleModal,
  setSelectedContract,
  statusColors,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      <AnimatePresence>
        {currentContracts.map((contract) => (
          <ContractGridItem
            key={contract._id}
            contract={contract}
            isAdmin={isAdmin}
            toggleModal={toggleModal}
            setSelectedContract={setSelectedContract}
            statusColors={statusColors}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ContractsGrid;
